import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Card from '@components/card-medium'
import CardXL from '@components/card-xl'
import Button from '@material-ui/core/Button'
import ButtonLink from '@components/atoms/button-link'

const GroupTopStories = (props) => {
  const {
    leadStory,
    secondaryStory,
    topStories = [],
    showAllStoriesLink,
    bordered,
  } = props

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={12} md={12}>
        {leadStory && <CardXL {...leadStory} />}
      </Grid>

      {secondaryStory && (
        <Grid item xs={12} sm={12} md={8}>
          <CardXL variant="lg" {...secondaryStory} bordered={bordered} />
        </Grid>
      )}

      {topStories.map(card => (
        <Grid item xs={12} sm={6} md={4} key={card.sys.id}>
          <Card {...card} bordered={bordered} />
        </Grid>
      ))}

      {showAllStoriesLink && (
        <Grid item xs={12}>
          <Box pt={2} pb={8} textAlign="center">
            <Button
              variant="outlined"
              component={ButtonLink}
              href="/stories/all"
              className="gtm-top-stories"
              dataAttrs={{
                'data-gtm-text': 'View all Stories',
              }}
            >
              View All Stories
            </Button>
          </Box>
        </Grid>
      )}

    </Grid>
  )
}

GroupTopStories.propTypes = {
  leadStory: PropTypes.object,
  secondaryStory: PropTypes.object,
  topStories: PropTypes.array,
  showAllStoriesLink: PropTypes.bool,
}

export default GroupTopStories
